import type { ModuleOptions } from '@nuxtjs/i18n'

import { genObjectWithDefaultKey, convertArrayToKeyedObject } from '../utils/common'

export enum LangEnum {
  ENG = 'en',
  TW = 'zh-tw',
  HK = 'zh-hk',
  CN = 'zh-cn',
  THAI = 'th',
}

export const DEFAULT_LANG_CODE = LangEnum.ENG
export const DEFAULT_LANG = 'en-US'

export const supportedLangs: ModuleOptions['locales'] = [
  { name: 'en-US', code: 'en', language: 'en-US', text: 'English', 'iso-abbrev': 'en' },
  { name: 'zh-TW', code: 'zh-tw', language: 'zh-TW', text: '繁體中文', 'iso-abbrev': 'zh' },
  { name: 'zh-HK', code: 'zh-hk', language: 'zh-HK', text: '繁體中文', 'iso-abbrev': 'hk' },
  { name: 'zh-CN', code: 'zh-cn', language: 'zh-CN', text: '简体中文', 'iso-abbrev': 'cn' },
  { name: 'th-TH', code: 'th', language: 'th-TH', text: 'ภาษาไทย', 'iso-abbrev': 'th' },
]

export const HAN_RELATED_LANGS = [LangEnum.TW, LangEnum.CN /* , LangEnum.JP */]

export const supportedLangsByCode = convertArrayToKeyedObject(supportedLangs, 'code')

export const supportedLangsByName = convertArrayToKeyedObject(supportedLangs, 'name')

function genThirdPartyLanguageMap(originMap: Record<string, any>) {
  return genObjectWithDefaultKey(originMap, DEFAULT_LANG_CODE)
}

/**
 * based on static analysis, variable cannot be used.
 * ref: https://github.com/rollup/plugins/tree/master/packages/dynamic-import-vars#limitations
 *
 * locales: https://github.com/tusen-ai/naive-ui/tree/0278f24ea34df0da0bdfe9a15ca627563c898771/src/locales/common
 */
export const nUILanguageModuleMap = genThirdPartyLanguageMap({
  [LangEnum.TW]: () => dynamicImport(() => import('naive-ui'), 'naive-ui-tw').then(({ zhTW, dateZhTW }) => [zhTW, dateZhTW]),
  [LangEnum.CN]: () => dynamicImport(() => import('naive-ui'), 'naive-ui-cn').then(({ zhCN, dateZhCN }) => [zhCN, dateZhCN]),
  [LangEnum.HK]: () => dynamicImport(() => import('naive-ui'), 'naive-ui-hk').then(({ zhCN, dateZhCN }) => [zhCN, dateZhCN]),
  [LangEnum.ENG]: () => dynamicImport(() => import('naive-ui'), 'naive-ui-eng').then(({ enUS, dateEnUS }) => [enUS, dateEnUS]),
  [LangEnum.THAI]: () => dynamicImport(() => import('naive-ui'), 'naive-ui-thai').then(({ thTH, dateThTH }) => [thTH, dateThTH]),
})

// locales: https://github.com/date-fns/date-fns/tree/main/src/locale
export const dateFnsLanguageMap = genThirdPartyLanguageMap({
  [LangEnum.TW]: () => dynamicImport(() => import('date-fns/locale/zh-TW'), 'date-fns/locale/zh-TW'),
  [LangEnum.CN]: () => dynamicImport(() => import('date-fns/locale/zh-CN'), 'date-fns/locale/zh-CN'),
  [LangEnum.HK]: () => dynamicImport(() => import('date-fns/locale/zh-HK'), 'date-fns/locale/zh-HK'),
  [LangEnum.ENG]: () => dynamicImport(() => import('date-fns/locale/en-US'), 'date-fns/locale/en-US'),
  [LangEnum.THAI]: () => dynamicImport(() => import('date-fns/locale/th'), 'date-fns/locale/th'),
})
